import { parsePlanBlocks, parseInlineSegments } from '../services/planTextParser'
import { downloadPlanPdf } from '../services/planPdf'

function renderInline(text) {
  return parseInlineSegments(text).map((seg, i) => seg.bold ? <strong key={i}>{seg.text}</strong> : <span key={i}>{seg.text}</span>)
}

function renderPlanBody(contenido) {
  const blocks = parsePlanBlocks(contenido)

  return blocks.map((block, idx) => {
    if (block.type === 'list') {
      return (
        <ul key={idx} style={{ margin: '0 0 10px', paddingLeft: 20 }}>
          {block.items.map((item, j) => <li key={j} style={{ marginBottom: 4 }}>{renderInline(item)}</li>)}
        </ul>
      )
    }
    if (block.type === 'space') return <div key={idx} style={{ height: 8 }} />
    if (block.type === 'h2') {
      return (
        <div key={idx} style={{ fontWeight: 700, fontSize: 17, color: '#111', marginTop: idx === 0 ? 0 : 24, marginBottom: 8, paddingTop: idx === 0 ? 0 : 14, borderTop: idx === 0 ? 'none' : '1px solid #e5e7eb' }}>
          {renderInline(block.text)}
        </div>
      )
    }
    if (block.type === 'h3') {
      return <div key={idx} style={{ fontWeight: 700, fontSize: 14, color: '#111', marginTop: 14, marginBottom: 4 }}>{renderInline(block.text)}</div>
    }
    return <div key={idx} style={{ marginBottom: 6 }}>{renderInline(block.text)}</div>
  })
}

export default function PrintPlan({ patientNombre, contenido, onClose }) {
  const today = new Date().toLocaleDateString('es', { day: 'numeric', month: 'long', year: 'numeric' })

  return (
    <div className="print-report-root" style={{ position: 'fixed', inset: 0, background: '#fff', zIndex: 100, overflow: 'auto', fontFamily: 'DM Sans, sans-serif' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;600;700&family=DM+Mono:wght@400;500&display=swap');
        @media print {
          .no-print { display: none !important; }
          body { background: #fff; }
          body * { visibility: hidden; }
          .print-report-root, .print-report-root * { visibility: visible; }
          .print-report-root {
            position: absolute !important;
            inset: 0 !important;
            left: 0 !important;
            top: 0 !important;
            overflow: visible !important;
            height: auto !important;
          }
        }
      `}</style>

      {/* Toolbar */}
      <div className="no-print" style={{
        position: 'sticky', top: 0, background: '#f9fafb', color: '#111',
        borderBottom: '1px solid #e5e7eb', padding: '12px 24px',
        display: 'flex', justifyContent: 'space-between', alignItems: 'center', zIndex: 10, flexWrap: 'wrap', gap: 8
      }}>
        <div style={{ fontWeight: 700, fontSize: 15 }}>Vista previa del plan</div>
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
          <button onClick={onClose} style={{
            padding: '8px 16px', borderRadius: 8, border: '1px solid #d1d5db',
            background: '#fff', color: '#111', cursor: 'pointer', fontFamily: 'DM Sans', fontSize: 14
          }}>← Volver</button>
          <button onClick={() => navigator.clipboard.writeText(contenido)} style={{
            padding: '8px 16px', borderRadius: 8, border: '1px solid #d1d5db',
            background: '#fff', color: '#111', cursor: 'pointer', fontFamily: 'DM Sans', fontSize: 14
          }}>📋 Copiar texto</button>
          <button onClick={() => downloadPlanPdf({ patientNombre, contenido })} style={{
            padding: '8px 16px', borderRadius: 8, border: 'none',
            background: '#16a34a', color: '#fff', cursor: 'pointer',
            fontFamily: 'DM Sans', fontWeight: 700, fontSize: 14
          }}>⬇️ PDF</button>
        </div>
      </div>

      {/* Plan */}
      <div style={{ maxWidth: 720, margin: '0 auto', padding: '40px 32px', color: '#111' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', borderBottom: '2px solid #111', paddingBottom: 16, marginBottom: 28 }}>
          <div>
            <div style={{ fontSize: 11, fontWeight: 600, letterSpacing: 2, color: '#6b7280', textTransform: 'uppercase', marginBottom: 6 }}>
              Plan nutricional
            </div>
            <div style={{ fontSize: 28, fontWeight: 700, letterSpacing: -0.5 }}>{patientNombre}</div>
          </div>
          <div style={{ textAlign: 'right', fontSize: 13, color: '#6b7280', fontFamily: 'DM Mono, monospace' }}>
            Generado: {today}
          </div>
        </div>

        <div style={{ border: '1px solid #e5e7eb', borderRadius: 12, padding: '20px 24px', fontSize: 14, lineHeight: 1.7 }}>
          {renderPlanBody(contenido)}
        </div>

        <div style={{ borderTop: '1px solid #e5e7eb', paddingTop: 16, marginTop: 28, display: 'flex', justifyContent: 'space-between', fontSize: 11, color: '#9ca3af' }}>
          <span>NutriControl · Documento confidencial · Uso clínico exclusivo</span>
          <span>{today}</span>
        </div>
      </div>
    </div>
  )
}
